<script setup>
function CorrectEmailaddress(SubscriberForm) {
  if (SubscriberForm.pf_Email.value.length > 255) {
    alert("Please enter at most 255 characters in the 'Email address' field.");
    SubscriberForm.pf_Email.focus();
    return false;
  }
  if (SubscriberForm.pf_Email.value == "") {
    alert("Please enter a value for the 'Email address' field.");
    SubscriberForm.pf_Email.focus();
    return false;
  }
  if (SubscriberForm.pf_Email.value.length < 7) {
    alert("Please enter at least 7 characters in the 'Email address' field.");
    SubscriberForm.pf_Email.focus();
    return false;
  }
  pf_Email = SubscriberForm.pf_Email.value;
  var reg =
    /^([a-zA-Z0-9_\-\.\+]*)([a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/;
  if (reg.test(pf_Email) == false) {
    alert("Your email address is not valid. Please try again.");
    SubscriberForm.pf_Email.focus();
    return false;
  }
  var counter = 0;
  for (i = 1; i <= SubscriberForm.pf_CounterMailinglists.value; i++) {
    var checkBoxName = "pf_MailinglistName" + i;
    if (
      document.getElementsByName(checkBoxName)[0].checked ||
      document.getElementsByName(checkBoxName)[0].type == "hidden"
    )
      counter++;
  }
  if (counter == 0) {
    alert("One or more mailing lists are required for this form.");
    return false;
  }
  return true;
}
//
document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector('form[name="SubscriberForm"]');
  var input = document.createElement("input");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", "g-recaptcha-token");
  input.setAttribute("id", "g-recaptcha-token");
  form.appendChild(input);

  var refreshToken = function () {
    grecaptcha
      .execute("6Lc20eAZAAAAAGQsCu8tKqLu3O5AtdjUrVE9AZtr", {
        action: "subscription_from_submit",
      })
      .then(function (token) {
        input.setAttribute("value", token);
      });
  };

  grecaptcha.ready(function () {
    refreshToken();
    setInterval(function () {
      refreshToken();
    }, 10000);
  });
});
</script>


<template>
  <div class="position-relative">
    <!-- eslint-disable -->
    <component
      class="d-none"
      is="script"
      src="https://www.google.com/recaptcha/api.js?render=6Lc20eAZAAAAAGQsCu8tKqLu3O5AtdjUrVE9AZtr"
      async
    ></component>

    <!-- eslint-enable -->

    <cookie-law theme="royal">
      <div slot="message" class="pl-md-5 ml-md-5">
        This site uses cookies 🍪
        <router-link to="privacy-policy" class="d-block"
          >Click here to read more</router-link
        >
      </div>
    </cookie-law>
    <b-container fluid class="sponsors">
      <b-row>
        <b-col xl="1"></b-col>
        <b-col>
          <h2 class="pt-5 green" style="font-size: 2rem">
            Our splendid partners & companies
          </h2>
        </b-col>
      </b-row>

      <b-row no-gutters>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://se.devoteam.com"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1681295064/2023_web/logos/Devoteam_TopoftheRock.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://www.couchbase.com/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1681644853/2023_web/logos/Couchbase_TopoftheRock.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://www.55degrees.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1684166568/2023_web/logos/55-degrees-logo.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://www.skatteverket.se"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1681644769/2023_web/logos/SKV_RGB_st.png"
              alt
              style="max-width: 57%"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://www.forsakringskassan.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1687762385/2023_web/logos/Screenshot_2023-06-26_at_08.52.33.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="http://www.trygghansa.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1687426193/2023_web/logos/Trygg-hansa_logo_web.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://www.truesec.com/how-we-help/our-services/development"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1687426193/2023_web/logos/Truesec_logo_web.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="http://www.sbab.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1687426193/2023_web/logos/SBAB_logo_web.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://www.fortnox.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1687426193/2023_web/logos/Fortnox_logo_web.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://www.skane.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1687426193/2023_web/logos/Regionska%CC%8Ane_logo_web.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://lifeat.axis.com/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1687426193/2023_web/logos/Axis_logo_web.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://www.castra.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1688115188/2023_web/logos/Castra_logo_web.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://modelon.com/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1688453702/2023_web/Modelon_logo_web.png"
              alt
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
            />
          </a>
        </b-col>

        <b-col md="3" class="gold">
          <a
            href="https://neo4j.com/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1688994577/2023_web/logos/Neo4j-logo-web.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold">
          <a
            href="https://debricked.com/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              class="mt-4 pt-3 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1697008617/2023_web/logos/DeBricked_by_OpenText_-_Logo_-_Navy.png"
              alt
            />
          </a>
        </b-col>
        <b-col
          md="3"
          class="d-flex align-items-center justify-content-center gold"
        >
          <a href="https://backyard-sessions.se/" target="_blank">
            <img
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1692947048/2023_web/logos/Backyard_sessions_logo.png"
              alt
            />
          </a>
        </b-col>
        <b-col
          md="3"
          class="d-flex align-items-center justify-content-center gold"
        >
          <a href="https://mule.to/p4rb" target="_blank">
            <img
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1694150666/2023_web/logos/stickermule_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col
          md="3"
          class="d-flex align-items-center justify-content-center gold"
        >
          <a href="http://www.sonatype.com/" target="_blank">
            <img
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1694175589/2023_web/logos/Sonatype_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col
          md="3"
          class="d-flex align-items-center justify-content-center gold"
        >
          <a href="https://ravendb.net/" target="_blank">
            <img
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1696514486/2023_web/logos/ravendb_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col
          md="3"
          class="d-flex align-items-center justify-content-center gold"
        >
          <a
            href="http://www.mediaevolution.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1697041067/2023_web/logos/Media_evolution_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col
          md="3"
          class="d-flex align-items-center justify-content-center gold"
        >
          <a
            href="https://codescene.com/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1697436894/2023_web/logos/Codescene_logo_web.png"
              alt
            />
          </a>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col xl="1"></b-col>

        <b-col>
          <h2 class="pt-5 green" style="font-size: 2rem">
            Media & press partners
          </h2>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://kodsnack.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1681295064/2023_web/logos/Kodsnack_mediapartners.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://kube.careers/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1681295064/2023_web/logos/KubeCareers_mediapartners.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://kube.events/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1681295064/2023_web/logos/KubeEvents_mediapartners.png"
              alt
            />
          </a>
        </b-col>

        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="http://mng.bz/d1oo
"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1683114378/2023_web/logos/ManningPublications_mediapartners.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://developerspodcast.com/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1683114377/2023_web/logos/developers_pressmedia.png"
              alt
            />
          </a>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col xl="1"></b-col>

        <b-col>
          <h2 class="pt-5 green" style="font-size: 2rem">Best companies</h2>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.qlik.com/us/"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1683025393/2023_web/logos/Qlik-Logo_RGB_1.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.pinkprogramming.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1693574093/2023_web/logos/pink_programming_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.refined.com/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              src="https://res.cloudinary.com/oredev/image/upload/c_scale,w_250/v1689075890/2023_web/logos/refined-logo.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="http://www.hogia.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              src="https://res.cloudinary.com/oredev/image/upload/v1694605650/2023_web/logos/hogia_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.forsvarsmakten.se/sv/organisation/forsvarsmaktens-telekommunikations-och-informationssystemforband-fmtis/?TSPD_101_R0=08054bd396ab2000f5a3d8cdcda188547fc2146b34855a3da03f37c7b8b2d2a686078b0950380ad1084b5de2fb143000e2634a741c52d41480d5a05f8e8ccb84ab65c33ac3bcab34cfc3ed258fd58bf2639672b8b6fc6458dd5b2addf8b968fc"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              class="mt-4 mt-sm-0"
              src="https://res.cloudinary.com/oredev/image/upload/v1695666654/2023_web/logos/forsvarsmakten_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.combitech.se/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1695969036/2023_web/logos/combitech_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.axxes.com/en"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1695969037/2023_web/logos/axxes_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.foocoding.org/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1696317955/2023_web/logos/foocoding_logo_web.png"
              alt
            />
          </a>
        </b-col>
        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.handelsbanken.se/sv/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1696876148/2023_web/logos/Handelsbanken_logo_web.png"
              alt
            />
          </a>
        </b-col>

        <b-col md="3" class="gold d-flex justify-content-center">
          <a
            href="https://www.redi-school.org/"
            target="_blank"
            class="d-flex align-items-center justify-content-center"
          >
            <img
              style="margin-top: 50px"
              class="mt-4 mt-sm-0 ml-0 ml-xl-5"
              src="https://res.cloudinary.com/oredev/image/upload/v1697041067/2023_web/logos/ReDi_School_logo_web.png"
              alt
            />
          </a>
        </b-col>
      </b-row>

      <b-col xl="1"></b-col>
    </b-container>

    <footer class="bg-color-dark text-color-light pt-5">
      <b-container fluid class="">
        <b-row>
          <!-- <b-col xl="2" class="left"> </b-col> -->
          <b-col>
            <b-container>
              <b-row>
                <b-col sm="12" md="8">
                  <h3 class="orange">Øredev Developer Conference</h3>
                  <h2 class="orange">8 - 10 Nov 2023 Sweden</h2>
                  <div class="newsletter mt-3 mb-5">
                    <form
                      action="https://oredev.us8.list-manage.com/subscribe/post?u=58a8d04056a9694a44fdbabf6&amp;id=d4cb377f54&amp;f_id=001806e0f0"
                      method="post"
                      id="mc-embedded-subscribe-form"
                      name="mc-embedded-subscribe-form"
                      class="validate"
                      target="_blank"
                      novalidate
                    >
                      <label class="i-cannot-be-spotted"
                        >Field <br /><input
                          type="text"
                          autocomplete="chrome-off"
                          name="namekjsd"
                      /></label>
                      <div class="input-group d-flex mb-3">
                        <input
                          placeholder="Subscribe to newsletter"
                          aria-label="Subscribe to newsletter"
                          style="border-radius: 0px; height: 42px"
                          value=""
                          type="email"
                          name="EMAIL"
                          class="form-control required email"
                          id="mce-EMAIL"
                          required
                        />

                        <!--       <div class="input-group-append">
                          <input
                            id="NewsletterSubmit"
                            type="submit"
                            name="Submit"
                            class="input-group-text green-bg text-dark"
                            value=">"
                          />
                        </div> -->
                        <b-button
                          id="NewsletterSubmit"
                          type="submit"
                          name="Submit"
                          class="input-group-text btn-1 d-none d-md-block"
                          style="margin-left: 10px"
                          value=""
                        >
                          Subscribe</b-button
                        >
                        <b-button
                          id="NewsletterSubmit"
                          type="submit"
                          name="Submit"
                          class="input-group-text d-block d-md-none btn-1"
                          value=""
                          style="width: 30px"
                        >
                          >
                        </b-button>
                        <p class="text-color-light mt-3">
                          This site is protected by reCAPTCHA and the Google

                          <a href="https://policies.google.com/privacy"
                            >Privacy Policy</a
                          >
                          and
                          <a href="https://policies.google.com/terms"
                            >Terms of Service</a
                          >
                          apply.
                        </p>
                      </div>
                      <!-- Do not change name or type on submit button, to change visible text, change text for \"value\" -->
                      <input
                        type="hidden"
                        name="pf_FormType"
                        value="OptInForm"
                      />
                      <input
                        type="hidden"
                        name="pf_OptInMethod"
                        value="SingleOptInMethod"
                      />
                      <input
                        type="hidden"
                        name="pf_CounterDemogrFields"
                        value="0"
                      />
                      <input
                        type="hidden"
                        name="pf_CounterMailinglists"
                        value="1"
                      />
                      <input type="hidden" name="pf_AccountId" value="10083" />
                      <input type="hidden" name="pf_ListById" value="1" />
                      <input type="hidden" name="pf_Version" value="2" />
                      <input
                        type="hidden"
                        name="pf_MailinglistName1"
                        value="200918"
                      />
                    </form>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="float-md-right">
                    <p>Keep in touch</p>
                    <p>Phone: +46(0)70 245 62 94</p>
                    <p>Email: info@oredev.org</p>
                    <p>Öredev AB</p>
                    <div class="d-flex">
                      <a
                        href="https://www.instagram.com/oredev/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://res.cloudinary.com/oredev/image/upload/v1687168584/2023_web/mdi_instagram.svg"
                          alt="Instagram"
                      /></a>

                      <a
                        href="https://www.linkedin.com/company/oredev/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="margin-top: 2px"
                        class="ml-2"
                      >
                        <img
                          src="https://res.cloudinary.com/oredev/image/upload/v1687168579/2023_web/akar-icons_linkedin-v1-fill.svg"
                          alt="Linkedin"
                        />
                      </a>
                      <a
                        href="https://www.facebook.com/oredev"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="ml-2"
                      >
                        <img
                          src="https://res.cloudinary.com/oredev/image/upload/v1687168582/2023_web/dashicons_facebook.svg"
                          alt="Facebook"
                        />
                      </a>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <p class="links mb-5 text-color-light">
                    <router-link to="/about" class>About Öredev</router-link> |
                    <router-link to="/code-of-conduct" class
                      >Code of conduct</router-link
                    >
                    | <router-link to="/archive" class>Archive</router-link> |
                    <router-link to="/committee" class>Committee</router-link>
                    <br />

                    <router-link to="/partnership" class
                      >Partnership</router-link
                    >
                    |
                    <router-link to="/privacy-policy" class
                      >Privacy Policy</router-link
                    >
                    |
                    <router-link to="/convince-your-boss" class
                      >Convince your boss</router-link
                    >
                  </p>
                </b-col>
              </b-row>
            </b-container>
          </b-col>

          <!-- <b-col xl="2" class="right"> </b-col> -->
        </b-row>
      </b-container>
    </footer>
    <img
      class="rectangle-red fluid"
      id="red-1"
      src="https://res.cloudinary.com/oredev/image/upload/v1679663725/2023_web/shapes%20info/Red-shape-1.png"
      alt="rectangle"
    />
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1679424058/2023_web/shapes%20lp/white-shape-5.png"
      class="d-none d-xl-block"
      id="white-shape-1"
    />
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";

export default {
  components: { CookieLaw },

  name: "Footer",
  data() {
    return {
      email: "",
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  updated: function () {},
  mounted: function () {},
  beforeMount: function () {},
  methods: {
    isEmailValid: function () {
      return this.email == ""
        ? ""
        : this.reg.test(this.email)
        ? "has-success"
        : "has-error";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";

.gold {
  max-height: 270px;
}

.gold > a {
}
p {
  text-align: left;
}

.text-center {
  margin-top: 0;
  padding: 0;
}
.sponsors {
  margin-top: 6rem;
  margin-bottom: 6rem;
}
.sponsors .silver {
  max-width: 50%;
}
.sponsors img {
  max-width: 90%;
}
.sponsors h2 {
  color: $pink;
}
.sponsors a {
  border: 1px solid #fff;
  display: block;
  text-align: center;
}
footer {
  margin-top: 12rem;
  padding: 10rem 0 0 0;
  // background: url(https://res.cloudinary.com/oredev/image/upload/2019/html/background-footer);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  @media (max-width: 576px) {
    margin-top: 6rem;
    padding: 5rem 0 2rem 0;
  }
}
footer h2,
footer h3 {
  text-transform: uppercase;
  margin: 0;
}
footer h2 {
  font-size: 2.7rem;
  margin-bottom: 30px;
  @media (max-width: 767px) {
    font-size: 2rem;
    margin-bottom: 10px;
  }
  @media (max-width: 576px) {
    font-size: 1.7rem;
  }
}
footer h3 {
  font-size: 2rem;
  @media (max-width: 767px) {
    font-size: 1.4rem;
  }
  @media (max-width: 576px) {
    font-size: 1.1rem;
  }
}

footer p.links {
  margin-top: 80px;
}
footer .middle {
  padding: 120px 0;
  color: #fff;
}
footer .newsletter {
  width: 100%;
  display: inline-block;
}
footer .left {
  background: url(https://res.cloudinary.com/oredev/image/upload/2019/html/theme-left-bottom);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom right;
}
footer .right {
  background: url(https://res.cloudinary.com/oredev/image/upload/2019/html/theme-right-bottom);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom left;
}
footer .links a {
  color: $text-color-light !important;
  font-size: 1rem;
}
footer .links a:hover {
  color: $orange !important;
}
>>> .Cookie--royal .Cookie__button {
  background: $orange !important;
}

>>> .Cookie--royal {
  background-color: $bg-dark;
  color: $text-color-light;
}

.i-cannot-be-spotted {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
}

#red-1 {
  bottom: 9%;
  mix-blend-mode: difference;
  position: absolute;
  max-width: 100%;
}

#white-shape-1 {
  position: absolute;
  right: 0;
  bottom: 5%;
}

#NewsletterSubmit {
  background: $bg-dark !important;
}

#NewsletterSubmit:hover {
  background: $orange !important;
}

@media screen and (max-width: 767px) {
  .form-control {
    width: 80% !important;
  }

  #NewsletterSubmit {
    width: 15% !important;
    margin-left: 2%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue